// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalProjectMove_base__3lrZf","label":"useModalProjectMove_label__37vJV","workspaceOptionDisabled":"useModalProjectMove_workspaceOptionDisabled__ujHkT"};